module.exports = __webpack_public_path__ + "img/11-9e93f8.png";